import { init as initAccordion, destroy as destroyAccordion } from '@theme/accordion';
import { init as initHeader, destroy as destroyHeader } from '@theme/header';
import { init as initSearchOverlay, destroy as destroySearchOverlay } from '@theme/search-overlay';
import { init as initCartDrawer, destroy as destroyCartDrawer } from '@theme/cart-drawer';
import { init as initProductAtc, destroy as destroyProductAtc } from '@theme/product-atc';
import { init as initSlider, destroy as destroySlider } from '@theme/slider';
import { init as initCarousel, destroy as destroyCarousel } from '@theme/carousel';
import { init as initDragScroll, destroy as destroyDragScroll } from '@theme/drag-scroll';
import { init as initReveal, destroy as destroyReveal } from '@theme/reveal';
import { init as initJudgemeTestimonials, destroy as destroyJudgemeTestimonials } from '@theme/judgeme-testimonials';

function init(root = document) {
  initAccordion(root);
  initHeader(root);
  initSearchOverlay(root);
  initCartDrawer(root);
  initProductAtc(root);
  initSlider(root);
  initCarousel(root);
  initDragScroll(root);
  initReveal(root);
  initJudgemeTestimonials(root);
}

function destroy(root = document) {
  destroyAccordion(root);
  destroyHeader(root);
  destroySearchOverlay(root);
  destroyCartDrawer(root);
  destroyProductAtc(root);
  destroySlider(root);
  destroyCarousel(root);
  destroyDragScroll(root);
  destroyReveal(root);
  destroyJudgemeTestimonials(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
} else {
  init();
}

document.addEventListener('shopify:section:load', (event) => {
  init(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroy(event.target);
});
